import SectionMessage from '@atlaskit/section-message';
import TagGroupDefault from "../../../../../../packages/design-system/tag-group/examples/constellation/tag-group-default";
import TagGroupAlignmentStart from "../../../../../../packages/design-system/tag-group/examples/constellation/tag-group-alignment-start";
import TagGroupAlignmentEnd from "../../../../../../packages/design-system/tag-group/examples/constellation/tag-group-alignment-end";
import AddTagsToGroupExample from "../../../../../../packages/design-system/tag-group/examples/5-add-tags";
import RAW_UNSAFE_atlaskitSLASHsection_message from "!!raw-loader!@atlaskit/section-message";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtag_group_default from "!!raw-loader!../../../../../../packages/design-system/tag-group/examples/constellation/tag-group-default";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtag_group_alignment_start from "!!raw-loader!../../../../../../packages/design-system/tag-group/examples/constellation/tag-group-alignment-start";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtag_group_alignment_end from "!!raw-loader!../../../../../../packages/design-system/tag-group/examples/constellation/tag-group-alignment-end";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASH5_add_tags from "!!raw-loader!../../../../../../packages/design-system/tag-group/examples/5-add-tags";
import * as React from 'react';
export default {
  SectionMessage,
  TagGroupDefault,
  TagGroupAlignmentStart,
  TagGroupAlignmentEnd,
  AddTagsToGroupExample,
  RAW_UNSAFE_atlaskitSLASHsection_message,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtag_group_default,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtag_group_alignment_start,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHtag_group_alignment_end,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASH5_add_tags,
  React
};